import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import LargePopper from '../assets/LargePopper';
import CircularProgress from '@mui/material/CircularProgress';

export const DataGridSelectFilter: React.ComponentType<{
  props: any;
  schema: any;
  columnData?: any;
  onChange: (value: any) => void;
}> = ({ props, onChange, columnData, schema }) => {
  const [filterOptions, setFilterOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const fetchSelectOptions = async () => {
    setLoading(true);
    schema.client.readNames().then((result: any) => {
      if (result?.data) {
        setFilterOptions(result.data);
      } else {
        setFilterOptions(result);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    if (columnData) {
      setLoading(true);
      const uniqueOptions = columnData
        .filter(
          (value: any, index: any, self: any) =>
            value?.id &&
            value?.name &&
            index === self.findIndex((v: any) => v?.id === value?.id)
        )
        .map((value: any) => ({ id: value?.id, name: value?.name }));
      setFilterOptions(uniqueOptions);
      setLoading(false);
    }
  }, [columnData]);

  const handleOnChange = (event: any, value: any) => onChange(value);

  return (
    <Autocomplete
      open={open}
      onOpen={()=>{
        setOpen(true);
        if (!columnData){
          fetchSelectOptions();
        }
      }}
      onClose={()=>setOpen(false)}
      PopperComponent={LargePopper}
      fullWidth
      size="small"
      options={filterOptions}
      getOptionLabel={(option: any) => option.name}
      getOptionKey={(option: any) => option.id}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      onChange={(event, newValue) => {
        handleOnChange(event, newValue);
      }}
      //onInputChange={debouncedOnChange}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            size="small"
            InputLabelProps={{
              style: {
                fontSize: 13,
                paddingTop: 2,
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        );
      }}
    />
  );
};
